import React, { useState, useRef, useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import "./index.css";

function AttentionDetail() {
  const controls = useAnimation();
  const textRef = useRef(null); // Ref for the text element
 
 
  const [percentage, setPercentage] = useState(0);
  const { ref, inView } = useInView({
    threshold: 0.6, 
    rootMargin: "-20% 0px -20% 0px", 
  });
  

  

  useEffect(() => {
    const handleScroll = () => {
      if (inView && textRef.current) {
        const rect = textRef.current.getBoundingClientRect();

       
        const adjustedViewportHeight = window.innerHeight * 0.4; 

        const scrollRangeStart = window.innerHeight * 0.3; 
        const scrollRangeEnd = adjustedViewportHeight + scrollRangeStart; 

        const scrollPercentage = Math.max(0, Math.min(1, (scrollRangeEnd - rect.top) / (scrollRangeEnd - scrollRangeStart))) * 100; 
        setPercentage(scrollPercentage)
     
      }
    };

   
    window.addEventListener("scroll", handleScroll);

  
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [inView]);

  
  useEffect(() => {
    if (inView) {
      controls.start({ opacity: 1, y: 0 });
    } else {
      controls.start({ opacity: 0.5, y: 0 });
    }
  }, [controls, inView]);

  return (
    <motion.div ref={ref} initial={{ opacity: 0.5, y: 0 }} animate={controls} transition={{ duration: 0.1, ease: "easeInOut" }} className="text-5xl attention center-align">
      <span>
        I have{" "}
        <motion.span
          ref={textRef}
          className="gradient-text text-5xl"
          style={{
            backgroundPositionX: `${percentage}%`,
          }}
        >
          strong
        </motion.span>{" "}
        obsession with attention to detail.
      </span>
    </motion.div>
  );
}

export default AttentionDetail;
